import React, { useEffect } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";

import * as actions from "../../store/actions/index";
import { withRouter } from "../../shared/utility";
import EmptyModal from "../../components/modals/EmptyModal";
import SunOrderForm from "../../components/forms/sunOrders/SunOrderForm";
import { useSunOrderFormViewModel } from "../../viewmodels/sunOrders/useSunOrderFormViewModel";

function CreateSunOrder(props: any) {
  const { logout, addSnackbar } = props;
  const navigate = useNavigate();
  const {
    customers,
    sunCustomers,
    employeeOptions,
    loading,
    emptyModal,
    setEmptyModelOpen,
    showErrorModal,
    getCustomersForDropdown,
    getSunCustomersForDropdown,
    getEmployeesForDropdown,
    getMyProducts,
    createOrderApiCall,
    onUpdateOrderItem,
    updateOrderItemUnitCost,
    deleteOrderItemApiCall,
    addProductToOrderApiCall,
  } = useSunOrderFormViewModel(logout, addSnackbar);

  useEffect(() => {
    getEmployeesForDropdown([1, 2], [1, 6]);
    getCustomersForDropdown();
    getSunCustomersForDropdown();
  }, []);

  const createSunOrder = async (values: any) => {
    const result = await createOrderApiCall(values);
    if (result.success) {
      navigate("/shippings");
    }
  };

  return (
    <div>
      <div className="mt-2 px-4 sm:px-8">
        <div className="sm:items-center">
          <div className="sm:flex-auto">
            <h1 className="text-xl font-semibold leading-6 text-gray-900">
              Create Sun Order
            </h1>
          </div>
          <div className="mt-5">
            <SunOrderForm
              customers={customers}
              sunCustomers={sunCustomers}
              getMyProducts={getMyProducts}
              employeeOptions={employeeOptions}
              isEdit={false}
              loading={loading}
              setEmptyModelOpen={setEmptyModelOpen}
              showErrorModal={showErrorModal}
              createOrderApiCall={createSunOrder}
              onUpdateOrderItem={onUpdateOrderItem}
              updateOrderItemUnitCost={updateOrderItemUnitCost}
              deleteOrderItemApiCall={deleteOrderItemApiCall}
              addProductToOrderApiCall={addProductToOrderApiCall}
            />
          </div>
        </div>
      </div>
      <EmptyModal
        childComponent={emptyModal.childComponent}
        open={emptyModal.open}
        setOpen={setEmptyModelOpen}
      />
    </div>
  );
}

const mapDispatchToProps = (dispatch: any) => ({
  logout: () => dispatch(actions.logout()),
  addSnackbar: (snackbar: any) => dispatch(actions.addSnackbar(snackbar)),
});

export default withRouter(connect(null, mapDispatchToProps)(CreateSunOrder));
